module.exports = __webpack_public_path__ + "media/bootstrap-icons/keyboard-3c29e899.svg";